<script>
import lazyLoadComponent from '@router/lazyload-component'
import { isTempleModule } from '@utils'

export default {
  components: {
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isEditMode() {
      return this.defaultValue.id
    },
    isEmptyByOrderExtrafields() {
      return this.defaultValue.byOrderExtrafields instanceof Array || this.defaultValue.byOrderExtrafields === undefined
    },
    isEmptyBySizeExtrafields() {
      if (this.defaultValue.customerInfos.length === 0) return true
      return this.defaultValue.customerInfos[0].bySizeExtrafields instanceof Array
    },
    productType(){
      return this.defaultValue.productType
    },
    priceTitle() {
      const list = [] 
      this.defaultValue.params.forEach((item)=>{
        list.push(...Array(item.sizeTotal).fill(item.title))
      })
      return list
    },
    isUnpaid () {
      return this.defaultValue.status === 2
    }
  },
  created() {
    if (this.isEditMode) {
      this.watchComplexObject(this.defaultValue.byOrderExtrafields)
      this.defaultValue.customerInfos.map((customerInfo) => {
        this.watchComplexObject(customerInfo.bySizeExtrafields)
      })
    }
  },
  methods: {
    isTempleModule,
    watchComplexObject(Extrafields) {
      if (!this.isEmptyExtrafields(Extrafields)) {
        for (let index in Extrafields) {
          this.$watch(() => Extrafields[index], this.updateExtrafields, {
            deep: true,
          })
        }
      }
    },
    isEmptyExtrafields(Extrafields) {
      return Extrafields instanceof Array
    },
    updateExtrafields(newValue, oldValue) {
      newValue.edited = true
    },
    isLightModule(adminEdit) {
      return adminEdit === 1
    },
    isDisabled(adminEdit) {
      return this.isLightModule(adminEdit) && [0, 2].includes(this.defaultValue.status)
    },
  },
}
</script>

<template>
  <div>
    <div v-if="!isEmptyByOrderExtrafields" class="info-byOrder">
      <div class="el-form-item__label">參與資訊</div>
      <el-form-item
        v-for="(byOrderExtrafields, byOrderExtrafieldsIndex) in defaultValue.byOrderExtrafields"
        :key="`edit-byOrderExtrafields-${byOrderExtrafieldsIndex}`"
        :label="byOrderExtrafields.title"
        :class="$style['extra-field']"
      >
        <el-input v-model="byOrderExtrafields.value" type="text"></el-input>
      </el-form-item>
    </div>

    <div v-if="!isEmptyBySizeExtrafields" class="info-bySize">
      <div class="el-form-item__label">{{`${isTempleModule(productType) ? '登記' : '參與人'}資訊`}}</div>
      <BaseCollapse v-for="(customerInfo, index) in defaultValue.customerInfos" :key="`edit-customerInfo-${index}`" :title="isTempleModule(productType) ? priceTitle[index] : `參與人${index + 1}`" :class="$style['border']">
        <template v-for="(field, fieldIndex) in customerInfo.bySizeExtrafields"  >
          <el-form-item v-if="field.adminEdit !== 1" :key="`edit-customerInfo-${index}-${fieldIndex}`" :label="field.title" :class="$style['extra-field']">
            <el-input v-model="field.value" type="text"></el-input>
          </el-form-item>
          <el-form-item v-else-if="field.adminEdit === 1 && !isUnpaid" :key="`edit-customerInfo-${index}-${fieldIndex}`" :label="field.title" :class="$style['extra-field']">
            <BaseUpload v-if="field.type === 'light_image'" v-model="field.value" resource="staff"/>
            <el-input v-else v-model="field.value" type="text"></el-input>
          </el-form-item>
        </template>
      </BaseCollapse>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.border {
  border: 2px solid lightgray;
  border-radius: 4px;
  margin-bottom: 15px;
  > div {
    background: transparent;
  }
}
.extra-field {
  :global {
    .el-form-item__label {
      padding: 0;
      font-size: small;
    }
  }
}
.disabled {
  pointer-events: none;
  opacity: 0.3;
}
</style>
